<template>
    <span>
<!--        TODO: no tabbing while modal up-->
        <div class="modal-background"></div>
        <div class="modal-wrapper">
            <div v-if="!this.$auth.loggedIn" class="modal-title">
                Administrator Login
            </div>
            <div class="error">
                {{error}}
            </div>
            <div v-if="this.$auth.loggedIn">
               <button class="button" @click="logout" @keypress="logout">Logout</button>
            </div>
            <div v-else style="width: 100%; padding: 0 2em">
                <form id="form" class="modal-form"  @submit.prevent="login">
                    <label>Username<input ref="username"  autocomplete="username" type="text" autocapitalize="none" autocorrect="off"  v-model="username" name="username"></label>
                    <label>Password<input type="password" autocomplete="current-password" v-model="password" name="password"></label>
                    <input style="display:none" type="submit">
                </form>
                <div class="modal-buttons">
                    <div :class="{loading : loading}">
                        <button class="button" @click="close" @keypress="close">Cancel</button>
                        <button class="button-primary" @click="login"  @keypress="login">Login</button>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
  import axios from 'axios';
  export default {
    name: "GenericModal",
    props: [],
    data() {
      return {
        error: null,
        loading: false,
        username: "",
        password: ""
      }
    },
    methods: {
      focus() {
        this.$refs.username && this.$refs.username.focus();
      },
      close() {
        this.error = null;
        this.$emit('close');
      },
      login() {
        //console.log("login");
        this.error = null;
        let formData = new FormData();
        let username = this.username;
        let password = this.password;
        //this.loggedInUser = 'Logging In...';
        formData.append("username", username);
        formData.append("password", password);
        this.loading = true;
        axios.post('/login', formData, {headers: {'Content-Type': 'multipart/form-data'}})
          .then(response => {
            this.$auth.loggedIn = true;
            this.$auth.username = username;
            window.localStorage.setItem("username", username);
            //console.log(response);
            this.loading = false;
            this.$emit('close');
          }).catch(response => {
          //TODO make this make sense
          //TODO better error messages for different scenarios
          this.$auth.loggedIn = false;
          this.$auth.username = "";
          window.localStorage.removeItem("username");
          //console.log(response);
          this.error = "The User ID or Password is incorrect. Please try again.";
          this.loading = false;
        })
      },
      logout() {
        axios.get('/logout')
          .then(response => {
            this.$auth.loggedIn = false;
            this.$auth.username = "";
            window.localStorage.removeItem("username");
            //console.log(response);
            this.loading = false;
            this.$emit('close');
          }).catch(response => {
          //TODO make this make sense
          this.$auth.loggedIn = false;
          this.$auth.username = "";
          window.localStorage.removeItem("username");
          //console.log(response);
          this.loading = false;
        });
        //Remove local cookie?

      }
    }
  }
</script>

<style scoped lang="scss">
    .modal-title {
        padding: 1.5em 0 0.25em 0;
        font-size: 1.5rem;
        font-weight: bold;
    }
    .error {
        color: red;
        padding-bottom: 0.75em;
        height: 1em;
        
    }
    .modal-form {
        display: flex;
        flex-direction: column;
        label {
            width: 100%;
            display: block;
            font-weight: bold;
            font-size: 0.75rem;
            input {
                font-size: 1rem;
                width: 100%;
                box-sizing: border-box;
                margin-top: 0.2em;
                display: block;
                width: 100%;
            }
            padding-bottom: 1em;
        }
    }
    .modal-buttons {
        display: flex;
        justify-content: center;
        margin: 1.5em 0;
    }
    modal-buttons.loading {
        opacity: 0;
    }
    .button {
        margin: 0 1em;
        color: $beaverpurple2;
        border: 1px solid $beaverpurple2;
        border-radius: 5px;
        width: 6em;
        height: 2em;
        line-height: 1;
        font-size: .9rem;
        //TODO: move
        font-family: system-ui, -apple-system, sans-serif;
        font-weight: 600;
    }

    .button-primary {
        @extend .button;
        background-color: $beaverpurple2;
        color: white;
    }
    .modal-background {
        width: 100%;
        height: 100%;
        position: fixed;
        background-color: grey;
        opacity: 0.7;
        top: 0;
        left: 0;
        z-index: 1000000000000;
    }

    .modal-wrapper {
        position: fixed;
        left: 50%;
        top: 15%;   //Make relative to header
        transform: translate(-50%, 0);
        box-sizing: border-box;
        min-height: 10em;
        width: 32em;
        $wrapper-padding: 1.5em;
        padding: 0 $wrapper-padding;
        background: white;

        border: 1px solid black;
        border-radius: 3px;
        //box-shadow: 0 0 2px 3px;//, 0 0 0px 0px inset;

        z-index: 1000000000001;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: 0.5em;
        @media only screen and (max-width: 768px) {
            transform: none;
            position: fixed;
            left: 10%;
            top: 3.5rem;
            //height: calc(100% - 5rem);
            width: 80%;
        }
    }
</style>
